import React, { Component } from 'react';
import { message, Form, Input, Button, notification } from 'antd';
import { fetchData } from '../lib/apis';
import OrderCustomerFields from './order-customer-fields';
import OrderVariantPicker from './order-variant-picker';
import OrderPricingSummary from './order-pricing-summary';

notification.config({
    placement: 'topRight',
    bottom: 50,
    duration: 3,
    top: 100
});

export default class FormCreateOrder extends Component {
    constructor(props) {
        super(props);
        this.contact = this.props.contactInfoSelected;
        const customerInfo = this.resolveCustomerInfo(this.contact);

        this.state = {
            reload: false,
            draftItems: [],
            btnLoading: false,
            draftOrderId: '',
            orderCode: '',
            orderStatus: '',
            customerName: customerInfo.name,
            customerPhone: customerInfo.phone,
            customerAddress: customerInfo.address,
            addressProvinces: [],
            addressWards: [],
            loadingAddressProvinces: false,
            loadingAddressWards: false
        };
    }

    resolveCustomerInfo = (contact) => {
        const from = contact && contact.from ? contact.from : {};
        const extractedInfo = contact && contact.ai_info && contact.ai_info.extracted_info ? contact.ai_info.extracted_info : {};
        const phoneList = contact && contact.phone_list && contact.phone_list.length > 0 ? contact.phone_list : [];

        return {
            name: (
                from.full_name_other
                || from.full_name
                || contact.full_name
                || contact.thread_title
                || contact.username
                || ''
            ),
            phone: (
                from.phone
                || from.phone2
                || extractedInfo.phone
                || phoneList[0]
                || ''
            ),
            address: (
                from.address
                || extractedInfo.address
                || ''
            ),
            email: (
                from.email
                || extractedInfo.email
                || ''
            )
        };
    }

    getCustomerFormValues = (contact) => {
        const customerInfo = this.resolveCustomerInfo(contact);
        return {
            full_name: customerInfo.name,
            phone: customerInfo.phone,
            address: customerInfo.address
        };
    }

    componentDidMount() {
        this.initializeOrderForm(this.props);
        this.loadAddressProvinces();
    }

    componentWillReceiveProps(nextProps) {
        const nextContactId = nextProps.contactInfoSelected && nextProps.contactInfoSelected.contact_id;
        const currentContactId = this.contact && this.contact.contact_id;
        const nextOrderId = nextProps.orderDetail && nextProps.orderDetail._id;
        const currentOrderId = this.props.orderDetail && this.props.orderDetail._id;
        const modeChanged = nextProps.orderMode !== this.props.orderMode;
        const formSessionChanged = nextProps.orderFormSession !== this.props.orderFormSession;

        if ((nextContactId && nextContactId !== currentContactId) || nextOrderId !== currentOrderId || modeChanged || formSessionChanged) {
            this.contact = nextProps.contactInfoSelected;
            this.initializeOrderForm(nextProps);
        } else if (nextProps.contactInfoSelected && !this.contact) {
            this.contact = nextProps.contactInfoSelected;
            this.initializeOrderForm(nextProps);
        }
    }

    initializeOrderForm = (props = this.props) => {
        const nextContact = props.contactInfoSelected;
        this.contact = nextContact;

        const nextCustomerInfo = this.resolveCustomerInfo(nextContact);

        this.setState({
            customerName: nextCustomerInfo.name,
            customerPhone: nextCustomerInfo.phone,
            customerAddress: nextCustomerInfo.address,
            draftItems: [],
            draftOrderId: '',
            orderCode: '',
            orderStatus: ''
        }, async () => {
            if (this.formH) {
                this.formH.resetFields();
                this.formH.setFieldsValue({
                    ...this.getCustomerFormValues(this.contact),
                    discount: 0,
                    shipping_fee: 0,
                    total_price: '0đ',
                    note: ''
                });
            }

            if (props.orderDetail) {
                await this.applyOrderToForm(props.orderDetail);
                return;
            }

            if (props.hydrateCreateOrderFromDraft === false) {
                this.setTotalPriceOrder();
                return;
            }

            await this.loadDraftOrder();
        });
    }

    setDraftItems = (draftItems = []) => {
        this.setState({ draftItems }, () => {
            this.setTotalPriceOrder();
        });
    }

    buildOrderItemsPayload = () => {
        return this.state.draftItems.map((item) => ({
            variant_id: item.variant_id,
            quantity: item.quantity,
            image: `${item.image || ''}`.trim()
        }));
    }

    getSubtotal = () => {
        return this.state.draftItems.reduce((sum, item) => {
            return sum + (Number(item.sale_price || 0) * Number(item.quantity || 0));
        }, 0);
    }

    getDiscountLimit = (fallbackValues = {}) => {
        const subtotal = this.getSubtotal();
        if (!this.formH || typeof this.formH.getFieldValue !== 'function') {
            const shippingFee = parseInt(fallbackValues.shipping_fee || 0, 10) || 0;
            return subtotal + shippingFee;
        }

        const shippingFee = parseInt(this.formH.getFieldValue('shipping_fee') || 0, 10) || 0;
        return subtotal + shippingFee;
    }

    getSafeFieldValue = (fieldName, fallbackValue = 0) => {
        if (!this.formH || typeof this.formH.getFieldValue !== 'function') {
            return fallbackValue;
        }

        return this.formH.getFieldValue(fieldName);
    }

    setSafeFieldValues = (values) => {
        if (this.formH && typeof this.formH.setFieldsValue === 'function') {
            this.formH.setFieldsValue(values);
        }
    }

    validateDiscountFields = () => {
        if (this.formH && typeof this.formH.validateFields === 'function') {
            this.formH.validateFields(['discount']);
        }
    }

    normalizeDiscountValue = (discountValue, fallbackValues = {}) => {
        const numericDiscount = parseInt(discountValue || 0, 10) || 0;
        return Math.min(numericDiscount, this.getDiscountLimit(fallbackValues));
    }

    setTotalPriceOrder = () => {
        if (!this.formH) return;

        let shipping_fee = this.getSafeFieldValue('shipping_fee', 0);
        let discount = this.getSafeFieldValue('discount', 0);
        shipping_fee = shipping_fee ? parseInt(shipping_fee, 10) : 0;
        discount = this.normalizeDiscountValue(discount, { shipping_fee });

        const subtotal = this.getSubtotal();
        const total = subtotal + shipping_fee - discount;

        this.setSafeFieldValues({
            discount,
            total_price: `${new Intl.NumberFormat('vi-VN').format(total).replace(/\./g, ',')}đ`
        });
    }

    validateDiscount = (_, value) => {
        const discountValue = parseInt(value || 0, 10) || 0;
        const limit = this.getDiscountLimit();

        if (discountValue > limit) {
            return Promise.reject(new Error('Giảm giá không được lớn hơn tổng tiền sản phẩm và phí vận chuyển'));
        }

        return Promise.resolve();
    }

    handleDiscountBlur = () => {
        this.setTotalPriceOrder();
        this.validateDiscountFields();
    }

    handlePricingBlur = () => {
        this.setTotalPriceOrder();
        this.validateDiscountFields();
    }

    prepareOrderValues = async () => {
        const values = await this.formH.validateFields();
        const discount = this.normalizeDiscountValue(values.discount, values);

        if (discount !== (parseInt(values.discount || 0, 10) || 0)) {
            this.setSafeFieldValues({ discount });
            if (this.formH && typeof this.formH.validateFields === 'function') {
                await this.formH.validateFields(['discount']);
            }
        }

        return {
            ...values,
            discount
        };
    }


    buildOrderPayload = (values) => {
        const payload = {
            customer: this.buildCustomerPayload(values),
            items: this.buildOrderItemsPayload(),
            notes: {
                internal: values.note || ''
            },
            source: this.buildSourcePayload()
        };

        if (Object.prototype.hasOwnProperty.call(values, 'discount')) {
            payload.discount = values.discount || 0;
        }
        if (Object.prototype.hasOwnProperty.call(values, 'shipping_fee')) {
            payload.shipping_fee = values.shipping_fee || 0;
        }

        return payload;
    }

    handleSubmit = async () => {
        this.setState({ btnLoading: true });
        try {
            const values = await this.prepareOrderValues();
            const payload = this.buildOrderPayload(values);

            const response = await fetchData({
                url: this.state.draftOrderId ? `api/v1/orders-v2/${this.state.draftOrderId}` : 'api/v1/orders-v2/draft',
                method: this.state.draftOrderId ? 'put' : 'post',
                data: payload
            });

            message.success({ content: 'Lưu đơn nháp thành công', key: 'orders' });
            this.setState({
                btnLoading: false,
                draftOrderId: response.data && response.data._id ? response.data._id : this.state.draftOrderId,
                orderCode: response.data && response.data.order_code ? response.data.order_code : this.state.orderCode,
                orderStatus: response.data && response.data.status ? response.data.status : (this.state.orderStatus || 'draft')
            }, () => {
                if (this.props.onOrderSaved) {
                    this.props.onOrderSaved(response.data || null);
                }
            });
        } catch (err) {
            this.setState({ btnLoading: false });
            message.error({ content: err.message || 'Đã có lỗi xảy ra', key: 'orders' });
        }
    }

    handleConfirmOrder = async () => {
        try {
            const values = await this.prepareOrderValues();
            this.setState({ btnLoading: true });

            const payload = {
                order_id: this.state.draftOrderId,
                ...this.buildOrderPayload(values)
            };

            const response = await fetchData({
                url: 'api/v1/orders-v2/confirm',
                method: 'post',
                data: payload
            });

            this.setState({ btnLoading: false }, () => {
                this.resetOrderFormState();
                if (this.props.onOrderConfirmed) {
                    this.props.onOrderConfirmed(response.data || null);
                }
            });
            message.success({ content: 'Xác nhận đơn hàng thành công', key: 'orders-confirm' });
        } catch (err) {
            this.setState({ btnLoading: false });
            message.error({ content: err.message || 'Xác nhận đơn hàng thất bại', key: 'orders-confirm' });
        }
    }

    buildSourcePayload = () => {
        return {
            type: 'manual_chat',
            user_id: this.contact ? this.contact.user_id : '',
            contact_id: this.contact ? this.contact.contact_id : '',
            channel_id: this.contact && this.contact.user_owner ? this.contact.user_owner.user_id : '',
            channel_type: this.contact && this.contact.user_owner ? this.contact.user_owner.acc_type : ''
        };
    }

    buildCustomerPayload = (values) => {
        const province = this.state.addressProvinces.find((item) => `${item.id}` === `${values.province_id}`) || {};
        const ward = this.state.addressWards.find((item) => `${item.id}` === `${values.ward_id}`) || {};
        return {
            name: values.full_name || '',
            phone: values.phone || '',
            address_line: values.address || '',
            province: {
                id: values.province_id || '',
                code: province.code || '',
                name: province.name || '',
                provider_ids: province.provider_ids || { viettel_post: values.province_id || '' }
            },
            district: { id: '', code: '', name: '', provider_ids: {} },
            ward: {
                id: values.ward_id || '',
                code: ward.code || '',
                name: ward.name || '',
                provider_ids: ward.provider_ids || { viettel_post: values.ward_id || '' }
            },
            address_resolution: {
                raw_input: values.address || '',
                method: 'manual',
                status: 'confirmed',
                confidence: 1,
                confirmed_by_customer: true,
                confirmed_at: Date.now(),
                dataset_version: ward.dataset_version || province.dataset_version || ''
            }
        };
    }

    loadAddressProvinces = async () => {
        this.setState({ loadingAddressProvinces: true });
        try {
            const response = await fetchData({ url: 'api/v1/addresses/provinces' });
            this.setState({ addressProvinces: Array.isArray(response.data) ? response.data : [], loadingAddressProvinces: false });
        } catch (error) {
            this.setState({ addressProvinces: [], loadingAddressProvinces: false });
            message.error('Không tải được danh mục Tỉnh / Thành phố');
        }
    }

    loadAddressWards = async (provinceId) => {
        if (!provinceId) {
            this.setState({ addressWards: [] });
            return;
        }
        this.setState({ loadingAddressWards: true });
        try {
            const response = await fetchData({ url: `api/v1/addresses/wards?province_id=${encodeURIComponent(provinceId)}` });
            this.setState({ addressWards: Array.isArray(response.data) ? response.data : [], loadingAddressWards: false });
        } catch (error) {
            this.setState({ addressWards: [], loadingAddressWards: false });
            message.error('Không tải được danh mục Phường / Xã');
        }
    }

    handleAddressProvinceChange = async (provinceId) => {
        if (this.formH) this.formH.setFieldsValue({ ward_id: undefined });
        await this.loadAddressWards(provinceId);
    }

    applyOrderToForm = async (order) => {
        if (!order) return;

        const provinceId = order.customer && order.customer.province ? order.customer.province.id : undefined;
        const wardId = order.customer && order.customer.ward ? order.customer.ward.id : undefined;
        if (provinceId) await this.loadAddressWards(provinceId);

        this.setState({
            draftOrderId: order._id || '',
            orderCode: order.order_code || '',
            orderStatus: order.status || '',
            draftItems: (order.items || []).map((item) => ({
                variant_id: item.variant_id,
                sku: item.variant_snapshot ? item.variant_snapshot.sku : '',
                name: item.variant_snapshot ? item.variant_snapshot.name : '',
                attributes: item.variant_snapshot ? (item.variant_snapshot.attributes || item.variant_snapshot.variant_attributes || {}) : {},
                image: item.variant_snapshot ? item.variant_snapshot.image || '' : '',
                sale_price: item.unit_price || item.sale_price || 0,
                quantity: item.quantity || 1
            }))
        }, () => {
            if (this.formH) {
                this.formH.setFieldsValue({
                    full_name: order.customer ? order.customer.name : this.state.customerName,
                    phone: order.customer ? order.customer.phone : this.state.customerPhone,
                    address: order.customer ? order.customer.address_line : '',
                    province_id: provinceId,
                    ward_id: wardId,
                    discount: order.pricing ? order.pricing.discount : 0,
                    shipping_fee: order.pricing ? order.pricing.shipping_fee : 0,
                    total_price: `${new Intl.NumberFormat('vi-VN').format(order.pricing ? order.pricing.grand_total : 0).replace(/\./g, ',')}đ`,
                    note: order.notes ? order.notes.internal : ''
                });
            }
        });
    }

    resetOrderFormState = () => {
        const customerValues = this.getCustomerFormValues(this.contact);
        this.setState({
            draftOrderId: '',
            orderCode: '',
            orderStatus: '',
            draftItems: []
        }, () => {
            if (this.formH) {
                this.formH.setFieldsValue({
                    ...customerValues,
                    province_id: undefined,
                    ward_id: undefined,
                    discount: 0,
                    shipping_fee: 0,
                    total_price: '0đ',
                    note: ''
                });
            }
        });
    }

    loadDraftOrder = async () => {
        try {
            if (!this.contact || !this.contact.contact_id) return;
            const response = await fetchData({
                url: `api/v1/orders-v2/draft/latest?contact_id=${this.contact.contact_id}`
            });
            const draft = response.data;
            if (!draft) {
                const customerValues = this.getCustomerFormValues(this.contact);
                this.setState({ draftOrderId: '', orderCode: '', orderStatus: '', draftItems: [] }, () => {
                    if (this.formH) {
                        this.formH.setFieldsValue({
                            ...customerValues,
                            discount: 0,
                            shipping_fee: 0
                        });
                    }
                    this.setTotalPriceOrder();
                });
                return;
            }

            await this.applyOrderToForm(draft);
        } catch (err) {
            this.setState({
                draftOrderId: '',
                orderCode: '',
                orderStatus: '',
                draftItems: []
            }, () => {
                if (this.formH) {
                    this.formH.setFieldsValue({ total_price: '0đ' });
                }
            });
        }
    }

    render() {
        const isDetailMode = this.props.orderMode === 'detail';
        const canConfirmOrder = this.state.orderStatus === 'draft' || !this.state.orderStatus;
        const submitLabel = isDetailMode
            ? (canConfirmOrder ? 'Cập nhật đơn' : 'Cập nhật thông tin')
            : 'Lưu nháp';

        return (
            <div id="form-create-order" className="order-form-shell">
                <Form
                    name="basic"
                    layout="vertical"
                    ref={(evt) => this.formH = evt}
                    className="order-form"
                    initialValues={{
                        full_name: this.state.customerName,
                        phone: this.state.customerPhone,
                        address: this.state.customerAddress,
                        discount: 0,
                        shipping_fee: 0,
                        total_price: '0đ'
                    }}
                >
                    <OrderCustomerFields
                        provinces={this.state.addressProvinces}
                        wards={this.state.addressWards}
                        loadingProvinces={this.state.loadingAddressProvinces}
                        loadingWards={this.state.loadingAddressWards}
                        selectedProvinceId={this.formH ? this.formH.getFieldValue('province_id') : undefined}
                        onProvinceChange={this.handleAddressProvinceChange}
                    />

                    <OrderVariantPicker
                        draftItems={this.state.draftItems}
                        onChange={this.setDraftItems}
                    />

                    {(this.state.orderCode || this.state.orderStatus) ? (
                        <section className="order-form-card order-status-card">
                            <div className="order-form-card__header">
                                <div className="order-form-card__icon"><i className="fas fa-info-circle" /></div>
                                <div className="order-form-card__title">Trạng thái đơn</div>
                            </div>
                            <div className="order-status-summary">
                                {this.state.orderCode ? <div className="order-status-summary__item"><span>Mã đơn</span><strong>{this.state.orderCode}</strong></div> : null}
                                {this.state.orderStatus ? <div className="order-status-summary__item"><span>Trạng thái</span><strong>{this.state.orderStatus}</strong></div> : null}
                            </div>
                        </section>
                    ) : null}

                    <section className="order-form-card order-note-card">
                        <div className="order-form-card__header">
                            <div className="order-form-card__icon"><i className="fas fa-align-left" /></div>
                            <div className="order-form-card__title">Ghi chú</div>
                        </div>
                        <Form.Item className="order-form-item order-note-card__field" name="note">
                            <Input.TextArea placeholder="Nhập ghi chú cho đơn hàng (ví dụ: giao giờ hành chính, đóng gói quà...)" autoSize={{ minRows: 4, maxRows: 6 }} />
                        </Form.Item>
                    </section>

                    <OrderPricingSummary
                        onRecalculate={this.handlePricingBlur}
                        onDiscountBlur={this.handleDiscountBlur}
                        discountRules={[{ validator: this.validateDiscount }]}
                    />

                    <Form.Item className="order-form-actions">
                        <Button
                            className="order-form-actions__button order-form-actions__button--secondary"
                            type="default"
                            onClick={this.handleSubmit}
                            loading={this.state.btnLoading}
                            disabled={this.state.draftItems.length === 0}
                        >
                            {submitLabel}
                        </Button>
                        {canConfirmOrder ? (
                            <Button
                                className="order-form-actions__button order-form-actions__button--primary"
                                type="primary"
                                onClick={this.handleConfirmOrder}
                                loading={this.state.btnLoading}
                                disabled={this.state.draftItems.length === 0}
                                style={{
                                    color: '#fff'
                                }}
                            >
                                Xác nhận đơn
                            </Button>
                        ) : null}
                    </Form.Item>
                </Form>
            </div>
        );
    }
}
